import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = forwardRef(({ className = "", ...props }, ref) => {
  const [show, setShow] = useState(false);
  const testid = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"} className={`${className} pr-11`} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
        aria-label={show ? "Nascondi password" : "Mostra password"} title={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#4a8a56] transition-colors"
        data-testid={`${testid}-toggle`}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
